<template>
	<div class="indexContainer">
		<Header></Header>
		<div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="3000">
		    <!-- 轮播（Carousel）指标 -->
		    <ol class="carousel-indicators">
		        <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
		        <li data-target="#myCarousel" data-slide-to="1"></li>
		    </ol>   
		    <!-- 轮播（Carousel）项目 -->
		    <div class="carousel-inner">
		        <div class="item active">
		            <img src="../../assets/img/intelDevice/banner1.jpg">
		            <div class="carousel-caption"><a href="javascript:;">了解更多<span class="returnBack"></span></a></div>
		        </div>
		        <div class="item">
		            <img src="../../assets/img/intelDevice/banner2.jpg">
		        </div>
		    </div>
		    <!-- 轮播（Carousel）导航 -->
		    <a class="left carousel-control" href="#myCarousel" role="button" data-slide="prev">
		        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
		        <span class="sr-only">Previous</span>
		    </a>
		    <a class="right carousel-control" href="#myCarousel" role="button" data-slide="next">
		        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
		        <span class="sr-only">Next</span>
		    </a>
		</div>
		<div class="indexContentContainer">
			<DeviceBox :products-data="productsData"></DeviceBox>
			<DeviceBox :products-data="terminalsData"></DeviceBox>
			<DeviceBox :products-data="safeData"></DeviceBox>
			<DeviceBox :products-data="stateData"></DeviceBox>
			<DeviceBox :products-data="otherData"></DeviceBox>
		</div>
    <!-- <Suggest></Suggest> -->
		<Footer></Footer>
	</div>
</template>

<script>
	import { WOW } from '../../assets/js/wow.min.js'
	import Header from '../../components/common/header.vue'
	import Footer from '../../components/common/footer.vue'
	import DeviceBox from '../../components/common/device-small.vue'
  // import Suggest from '../../components/common/suggest.vue'
	
	export default{
		data() {
			return {
				productsData: {
						"id":"100001",
						"title": "仓储管理设备",
						"info": "实现对仓库的智能化管理，内嵌收货、存储、拣选、发货、库存控制、盘点等核心功能。",
						"bgImg": require("../../assets/img/intelDevice/bg1.jpg"),
						"sbgImg": require("../../assets/img/intelDevice/pic1.png"),
						"classifyName": [{"id":"100011","name":"立体货架"},{"id":"100031","name":"运输货物设备"},{"id":"100021","name":"提升设备"},{"id":"100041","name":"其他设备"}],
						"list": [
							{
								"id": "100011",
								"stitle": "立体货架",
								"child": [
									[{
										"img": require("../../assets/img/intelDevice/pic2.jpg"),
										"name": "横梁式托盘货架",
										"id": "100111",
										"detail": "横梁式货架结构简单、安全可靠，可任意调整组合，出入库不受物品先后顺序的限制。广泛应用于以托盘存储、叉车存取的仓储模式。"
									},
									{
										"img": require("../../assets/img/intelDevice/pic3.jpg"),
										"name": "电动移动式货架",
										"id": "100112",
										"detail": "与普通货架相比，可以提高地面80%左右的使用率。可提供100%左右拣选性。结构简单，安全可靠，停电也可应急移动。"
									},
									{
										"img": require("../../assets/img/intelDevice/pic4.jpg"),
										"name": "牛腿式周转箱货架",
										"id": "100113",
										"detail": "货物存取从货架同一侧进出，先存后取、后存先取，平衡重及前移式叉车可方便地驶入货架中间存取货物，无需占用多条通道。"
									},
									{
										"img": require("../../assets/img/intelDevice/pic5.jpg"),
										"name": "贯通式货架",
										"id": "100114",
										"detail": "贯通式货架广泛应用于 用于大批量、少品种的货物存储，这类货物包装统一、产品单一。"
									}]
								]
							},
							{
								"id": "100031",
								"stitle": "运输货物设备",
								"child": [
									[{
										"img": require("../../assets/img/intelDevice/pic6.jpg"),
										"name": "AGV无人搬运小车",
										"id": "100311",
										"detail": "AGV也称为自动导引车，是一种无人驾驶搬运车，是智能型移动机器人的一种。它可以按照上位机下达的指令，依照车载传感器确定位置信息，并根据事先设计的程序，沿着规定的路线自动行驶，或者在指定位置停靠，以完成一系列作业功能。主要用来储运各种物料，为系统柔性化、高效化、集成化提供有力保障。"
									},
									{
										"img": require("../../assets/img/intelDevice/pic7.jpg"),
										"name": "穿梭车",
										"id": "100312",
										"detail": "存储量大、存储灵活、先进先出、系统柔性高、自动充电诊断、安全性高、使用维护方便。"
									},
									{
										"img": require("../../assets/img/intelDevice/pic8.jpg"),
										"name": "四向穿梭车",
										"id": "100313",
										"detail": "主要应用于密集存储仓储库区出入库作业搬运，可实现X、Y方向自动转向搬运作业。"
									},
									{
										"img": require("../../assets/img/intelDevice/pic9.jpg"),
										"name": "子母穿梭车",
										"id": "100314",
										"detail": "自动化程度高，实现全自动无人化作业。高承载，最高可载重1200kg；智能识别，精确定位；通过计算机技术的管理和调度实现信息物流转换成出入库货品，实现物流、 信息的高度 统一。"
									}]
								]
							},
							{
								"id": "100021",
								"stitle": "提升设备",
								"child": [
									[{
										"img": require("../../assets/img/intelDevice/pic10.jpg"),
										"name": "多功能托盘提升机",
										"id": "100211"
									},
									{
										"img": require("../../assets/img/intelDevice/pic11.jpg"),
										"name": "多层提升机",
										"id": "100212"
									},
									{
										"smallChild": [
											{
												"img": require("../../assets/img/intelDevice/pic12.jpg"),
												"name": "立体堆垛机",
												"id": "1002130"
											},
											{
												"img": require("../../assets/img/intelDevice/pic13.jpg"),
												"name": "反复式提升机",
												"id": "1002131"
											}
										]
									},
									{
										"smallChild": [
											{
												"img": require("../../assets/img/intelDevice/pic12.jpg"),
												"name": "Z型提升机",
												"id": "1002130"
											},
											{
												"img": require("../../assets/img/intelDevice/pic13.jpg"),
												"name": "C型提升机",
												"id": "1002131"
											}
										]
									}]
								]
							},
							{
								"id": "100041",
								"stitle": "其他设备",
								"child": [
									[{
										"img": require("../../assets/img/intelDevice/pic6.jpg"),
										"name": "堆垛机",
										"id": "100411",
										"detail": "与高层货架、出入库台或出入库系统等设备配套使用。"
									},
									{
										"img": require("../../assets/img/intelDevice/pic7.jpg"),
										"name": "拆叠盘机",
										"id": "100412",
										"detail": "主要应用于立库出入库系统的叠盘和拆盘等作业。"
									},
									{
										"img": require("../../assets/img/intelDevice/pic8.jpg"),
										"name": "输送机",
										"id": "100413",
										"detail": "一种采用振动电机驱动，利用偏心块旋转时所产生的惯性力作为激振源，激振源使槽体沿某一倾斜方向产生振动，从而将物料从某一位置输送到另一位置的一种输送机。"
									},
									{
										"img": require("../../assets/img/intelDevice/pic9.jpg"),
										"name": "拆码垛一体机",
										"id": "100414",
										"detail": "标准纸箱拆码垛一体机是一种输送线自动件烟拆分搬运设备，集输送线标准纸箱码垛/拆垛功能为一体，可执行拆垛、码垛，极大地提高了物流输送效率。"
									}]
								]
							},
						]
				},
				terminalsData: {
						"id":"200001",
						"title": "货物跟踪设备",
						"info": "实现对车辆和货物位置和轨迹的实时追踪，保证货物快速安全的抵达目的地。",
						"bgImg": require("../../assets/img/intelDevice/bg2.jpg"),
						"sbgImg": require("../../assets/img/intelDevice/pic20.png"),
						"classifyName": [{"id":"200011","name":"车载终端"},{"id":"200021","name":"小型定位器"}],
						"list": [
							{
								"id": "200011",
								"stitle": "车载终端 <span class='small'>（安装在车辆上对车辆位置和行驶轨迹进行实时追踪）</span>",
								"child": [
									[{
										"img": require("../../assets/img/intelDevice/pic21.jpg"),
										"name": "新能源物流车车载终端",
										"id": "200111",
										"detail": "轨迹完美回放、远程监控、获取定位数据、支持双路can数据接入、支持语音播报功能、能够监听车辆、上传报警数据、接口丰富、支持国标。。"
									},
									{
										"img": require("../../assets/img/intelDevice/pic22.jpg"),
										"name": "交通部部标行车记录仪",
										"id": "200112",
										"detail": "位置查询、车辆轨迹查询、车辆参数查询、上传报警功能、图像采集功能。"
									},
									{
										"img": require("../../assets/img/intelDevice/pic23.jpg"),
										"name": "新能源乘用车终端",
										"id": "200113",
										"detail": "轨迹完美回放、远程监控、获取定位数据、支持双路can数据接入、能够监听车辆、上传报警数据、接口丰富、支持国标。"
									}]
								]
							},
							{
								"id": "200021",
								"stitle": "小型定位器<span class='small'>（比较贵重的货物中放置小型定位器，跟踪货物位置，保障货物的安全性）",
								"child": [
									[{
										"img": require("../../assets/img/intelDevice/pic24.jpg"),
										"name": "微型GPS跟踪定位器",
										"id": "200211"
									},
									{
										"img": require("../../assets/img/intelDevice/pic26.jpg"),
										"name": "强磁免安装CPS定位器",
										"id": "200212"
									},
									{
										"isSmall": true,
										"smallChild": [
											{
												"img": require("../../assets/img/intelDevice/pic28.jpg"),
												"name": "强磁免安装CPS定位器",
												"id": "200212"
											},
											{
												"img": require("../../assets/img/intelDevice/pic30.jpg"),
												"name": "强磁免安装CPS定位器",
												"id": "200212"
											}
										]
									}],
									[{
										"img": require("../../assets/img/intelDevice/pic25.jpg"),
										"name": "微型GPS跟踪定位器",
										"id": "200211"
									},
									{
										"img": require("../../assets/img/intelDevice/pic27.jpg"),
										"name": "强磁免安装CPS定位器",
										"id": "200212"
									},
									{
										"isSmall": true,
										"smallChild": [
											{
												"img": require("../../assets/img/intelDevice/pic29.jpg"),
												"name": "强磁免安装CPS定位器",
												"id": "200212"
											},
											{
												"img": require("../../assets/img/intelDevice/pic31.jpg"),
												"name": "强磁免安装CPS定位器",
												"id": "200212"
											}
										]
									}]
								]
							}
						]
				},
				safeData: {
						"id":"300001",
						"title": "驾驶安全设备",
						"info": "实现对车辆行驶全过程的视频图像和声音记录。",
						"bgImg": require("../../assets/img/intelDevice/bg3.jpg"),
						"sbgImg": require("../../assets/img/intelDevice/pic32.png"),
						"classifyName": [],
						"list": [
							{
								"id": "300011",
								"child": [
									[{
										"img": require("../../assets/img/intelDevice/pic33.jpg"),
										"name": "1080P",
										"id": "300111"
									},
									{
										"img": require("../../assets/img/intelDevice/pic34.jpg"),
										"name": "单双倍镜头",
										"id": "300112"
									},
									{
										"img": require("../../assets/img/intelDevice/pic35.jpg"),
										"name": "高清夜视",
										"id": "300113"
									}],
									[{
										"img": require("../../assets/img/intelDevice/pic36.jpg"),
										"name": "后视镜",
										"id": "300111"
									},
									{
										"img": require("../../assets/img/intelDevice/pic37.jpg"),
										"name": "迷你无线",
										"id": "300112"
									},
									{
										"img": require("../../assets/img/intelDevice/pic38.jpg"),
										"name": "双镜头",
										"id": "300113"
									}]
								]
							}
						]
				},
				stateData: {
						"id":"400001",
						"title": "状态感知设备",
						"info": "实现对车辆、仓库等温度、湿度、油量等的监控和分析。",
						"bgImg": require("../../assets/img/intelDevice/bg4.jpg"),
						"sbgImg": require("../../assets/img/intelDevice/pic39.png"),
						"classifyName": [],
						"list": [
							{
								"id": "400011",
								"child": [
									[{
										"img": require("../../assets/img/intelDevice/pic40.jpg"),
										"name": "温度传感器",
										"id": "400111"
									},
									{
										"img": require("../../assets/img/intelDevice/pic41.jpg"),
										"name": "门磁传感器",
										"id": "400112"
									},
									{
										"img": require("../../assets/img/intelDevice/pic42.jpg"),
										"name": "超声",
										"id": "400113"
									}],
									[{
										"img": require("../../assets/img/intelDevice/pic43.jpg"),
										"name": "人脸识别",
										"id": "400111"
									},
									{
										"img": require("../../assets/img/intelDevice/pic44.jpg"),
										"name": "ADAS",
										"id": "400112"
									},
									{
										"img": require("../../assets/img/intelDevice/pic45.jpg"),
										"name": "AI智能",
										"id": "400113"
									}]
								]
							}
						]
				},
				otherData: {
						"id":"500001",
						"title": "打印和扫码设备",
						"info": "支持扫码设备和蓝牙打印机打印标签功能，减少工作量，提高了工作效率。",
						"bgImg": require("../../assets/img/intelDevice/bg5.jpg"),
						"sbgImg": require("../../assets/img/intelDevice/pic46.png"),
						"classifyName": [],
						"list": [
							{
								"id": "500011",
								"child": [
									[{
										"img": require("../../assets/img/intelDevice/pic47.jpg"),
										"name": "扫码设备",
										"id": "500111"
									},
									{
										"img": require("../../assets/img/intelDevice/pic48.jpg"),
										"name": "蓝牙打印机",
										"id": "500112"
									},
									{
										"img": require("../../assets/img/intelDevice/pic49.jpg"),
										"name": "热敏标签",
										"id": "500113"
									}]
								]
							}
						]
				}
			}
		},
		components: {
			Header,
			Footer,
			DeviceBox,
      // Suggest
		},
		created: function(){
			new WOW({live: false}).init();
		},
		mounted: function(){
			new WOW({live: false}).init();
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/animate.min.css");
	.carousel-inner>.item>a>img, .carousel-inner>.item>img, .img-responsive, .thumbnail>img, .thumbnail a>img{
	    width: 100%;
	}
	.carousel-caption{
		width: 140px;
	    padding: 0;
	    height: 40px;
	    border: 1px solid #fff;
	    line-height: 40px;
	    background: rgba(255,255,255,0.1);
    	font-size: 18px;
    	z-index: 20;
        bottom: 25%;
    	left: 29%;
	}
	.carousel-inner .font-content{
		width: 63%;
		position: absolute;
		top: 20%;
		left: 50%;
		transform: translate(-50%, 0);
		z-index: 2;
		display: none;
		text-align: center;
	}
	.carousel-inner .font-content img{
		max-width: 100%;
	}
	.carousel-inner .font-content.active{
		display: block;
	}
	.carousel-caption a{
		color: #fff;
		display: block;
	}
	.carousel-caption a::before{
		display: block;
		position: absolute;
		top: 0px;
		right: 0px;
		height: 100%;
		width: 0px;
		z-index: -1;
		content: "";
		color: #000 !important;
		background: #ff6600;
		-webkit-transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1) 0s;
		-o-transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1) 0s;
		transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1) 0s;
	}
	.carousel-caption a:hover::before{
		left: 0%;
		right: auto;
		width: 100%;
	}
	.returnBack{
		display: inline-block;
		width: 22px;
		height: 14px;
		margin-left: 5px;
		background: url(../../assets/img/images/arrow.png) no-repeat;
		background-size: 100%;
	}
	.carousel-indicators li{
		width: 18px;
	    height: 18px;
	    margin: 0 20px;
	}
	.carousel-indicators .active{
		background-color: #ff6600;
	    border: none;
	    width: 18px;
	    height: 18px;
	    margin: 0 20px;
	}
	.indexContentContainer{
		background: #f0f0f0;
	}
</style>


// WEBPACK FOOTER //
// src/components/pages/intelligent_device.vue